import { useCallback } from 'react'
import { HttpClientConfig, useHttpClientConfig } from '../../useHttpClientConfig'
import { useServiceCountryUrl } from '../useServiceCountryUrl'
import { Page, User } from './types'
import { UserGetManyRequest, makeGetUsers, makeGetMe } from './users'

interface UsersService {
  getUsers: (filters: UserGetManyRequest) => Promise<Page<User>>
  getMe: () => Promise<User>
  isReady: boolean
}

const useUsersService = (): UsersService => {
  const { config } = useHttpClientConfig()
  const { url } = useServiceCountryUrl('user')

  const getUsers = useCallback(makeGetUsers(url.href, config as HttpClientConfig), [config, url.href])
  const getMe = useCallback(makeGetMe(url.href, config as HttpClientConfig), [config, url.href])

  return {
    getUsers,
    getMe,
    isReady: Boolean(config),
  }
}

export { useUsersService }
